import { render, staticRenderFns } from "./UserHelpView.vue?vue&type=template&id=8cace712&scoped=true&"
import script from "./UserHelpView.vue?vue&type=script&lang=ts&"
export * from "./UserHelpView.vue?vue&type=script&lang=ts&"
import style0 from "./UserHelpView.vue?vue&type=style&index=0&id=8cace712&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cace712",
  null
  
)

export default component.exports